/* eslint-disable no-unused-vars */
/**
 *  Copyright AlpineReplay Inc, 2022. All rights reserved.
 *  Authors: Drew Burnett
 */

// Imports

import { 
    FindProfileDocument, 
    useAddCollectionItemMutation, 
    useAddCollectionMutation 
} from "../generated/graphql"

// Create Playlist and Add Moment

export const useCreatePlaylistAndAddMoment = (token) => {

    // Add Collection Mutation
    const [
        addCollectionMutation,
        {
            data: addCollectionData,
            loading: addcollectionLoading, 
            error: addCollectionError
        }
    ] = useAddCollectionMutation({
        variables: {
            token: token,
        },
        refetchQueries: [FindProfileDocument, "findProfile"],
    })

    // Add Collection Item Mutation
    const [
        addCollectionItem,
        {
            data: addCollectionItemData,
            loading: addCollectionItemLoading,
            error: addCollectionItemError
        }
    ] = useAddCollectionItemMutation({
        variables: {
            token: token,
        },
        refetchQueries: [FindProfileDocument, "findProfile"]
    })

    const createPlaylistAndAddMoment = async (moment, profile, playlistName, isPrivate, collectionColor) => {
       return addCollectionMutation({
            variables: {
                edit: {
                    title: playlistName,
                    public: !isPrivate,
                    color: collectionColor
                },
                user_playlist_id: profile.user_playlist_id
            }
        }).then((response) => {
            if (response?.data?.addCollection?.success) {
                return addCollectionItem({
                    variables: {
                        hash_key: response.data.addCollection.hash_key,
                        add: {
                            user_playlist_clip_id: moment.game_clip_id
                        }
                    }
                }).then((res) => {
                    if (res?.data.addCollectionItem?.success) {
                        return [profile.hash_key, response.data.addCollection.hash_key, res.data.addCollectionItem.user_playlist_clip_id]
                    } else {
                        return [null, null, null]
                    }
                })
            } else {
                return [null, null, null]
            }
        })
    }

    return createPlaylistAndAddMoment
}